export default __webpack_public_path__ + "static/media/intro.887690c1.mp4";